import { useSetAtom } from "jotai";

import { $deleteDocumentWorkflow } from "../../internal/document";

/**
 * Handles deletion from all sources: disk (local), remote API, and cache (SQLite).
 */
export const useDeleteDocument = () => {
	return useSetAtom($deleteDocumentWorkflow);
};
